import {ColorUtils} from "@k/js/colorUtils";
import {Color} from "@k/js/colorObject";
import {
    PalettenCluster,
    PalettenClusterSorted,
    PalettenEintragFromDBWithFarbgruppenEinteilung
} from "@k/js/databaseInterfaceClasses";
import {ColorController} from "@k/js/controllerModules/colorController";
import {CONSTANTS} from "@k/js/meta_data";

import {ColorViewDataWithOutlineAndPatterns} from "@km/components/color/ColorViewDataWithOutlineAndPatterns";

export class ColorUtilsVue {

    private static noOutlineColorPalettenEntry = () => ({
        palette: "none",
        gruppenIndex: 0,
        farbgruppe: [],
        positionInGruppe: 1
    });

    public static hexWithPoundsign(colorObject: Color|ColorViewDataWithOutlineAndPatterns, key = "colorValue") {
        /** @var Color colorObject */
        if (colorObject === null || colorObject === undefined) {
            return "#" + CONSTANTS.COLORERROR;
        }
        return ColorUtils.decToHexWithPoundsign(colorObject[key]);
    }

    public static getColorPositionInfoForIntValue(intvalueOrnoneString: string|number, palettenCluster: PalettenClusterSorted, currentPalette:string)
        :null|{palette, gruppenIndex, positionInGruppe} {
        if (intvalueOrnoneString === "<none>") {
            return ColorUtilsVue.noOutlineColorPalettenEntry();
        }
        const hex = ColorUtils.decToHex(parseInt(intvalueOrnoneString as string));
        return ColorUtilsVue.getColorPositionInfoForHexstringFromPalette(hex, palettenCluster[currentPalette], currentPalette);
    }

    public static getPaletteForColorValueFromCluster(colorValueString, palettenCluster) {
        const hex = ColorUtils.decToHex(colorValueString);
        if(typeof (palettenCluster["AddedByOM Colors"]) !== "undefined") {
            if(palettenCluster["AddedByOM Colors"].find(c=>c.RGBHex === hex) !== undefined) {
                return "AddedByOM Colors";
            }
        }
        if(typeof (palettenCluster["Legacy Colors"]) !== "undefined") {
            if(palettenCluster["Legacy Colors"].find(c=>c.RGBHex === hex) !== undefined) {
                return "Legacy Colors";
            }
        }
        for(const palette in palettenCluster) {
            if(palettenCluster[palette].find(c=>c.RGBHex === hex) !== undefined) {
                return palette;
            }
        }
        return "";
    }

    private static getColorIndizesForHexString(hexString:string, palette:PalettenEintragFromDBWithFarbgruppenEinteilung[][]):{gruppenIndex:number, indexInGruppe:number}|null {
        let gruppenIndex;
        for(gruppenIndex=0; gruppenIndex < palette.length; gruppenIndex++) {
            const indexInGruppe = palette[gruppenIndex].findIndex(c=>c.RGBHex.toString() === hexString);
            if(indexInGruppe>-1) {
                return {gruppenIndex, indexInGruppe};
            }
        }
        return null;
    }

    private static getColorPositionInfoForHexstringFromPalette(hexstring:string, palette:PalettenEintragFromDBWithFarbgruppenEinteilung[][], palettenName)
        :null|{palette, positionInGruppe, gruppenIndex} {
        const indizes = ColorUtilsVue.getColorIndizesForHexString(hexstring, palette);
        if (indizes === null) {
            return null;
        }

        return {
            palette: palettenName,
            positionInGruppe: indizes.indexInGruppe,
            gruppenIndex:indizes.gruppenIndex
        };
    }

    public static getPalettenNameFromPalettenClusterWithColorHexValue(palettenCluster: PalettenCluster | null, colorHexvalue: string, quellpalette:string) {
        if(palettenCluster === null) {
            return "";
        }
        if(typeof(palettenCluster[quellpalette]) !== "undefined") {
            if (palettenCluster[quellpalette].find(c => c.RGBHex === colorHexvalue) !== undefined) {
                return quellpalette;
            }
        }
        for (const p in palettenCluster) {
            if (palettenCluster[p].find(c => c.RGBHex === colorHexvalue) !== undefined) {
                return p;
            }
        }
        return "";
    }

    public static intValueFromHex(hexValue: string) {
        return parseInt(hexValue.replace("#", ""), 16);
    }

    public static colorHexIsNearWhite(colorHexValue) {
        return ColorUtilsVue.colorIntIsNearWhite(ColorUtils.hexToDec(colorHexValue));
    }

    public static colorIntIsNearWhite(colorIntvalue) {
        return ColorUtilsVue.colorsAreNearToEachOther(colorIntvalue, ColorUtils.hexToDec("FFFFFF"));
    }

    public static colorsAreNearToEachOther(color1IntValue, color2IntValue) {
        return ColorController.getDeltaEFromIntValues(color1IntValue, color2IntValue) < CONSTANTS.DELTA_E_THRESHHOLD / 4;
    }


}
